import {combineReducers} from "redux";
import photos from "./photos";

export default combineReducers({photos});